const getUser = (state) => {
  return state.user
}

const getUserPending = (state) => {
  return state.userPending
}

const getUserRoles = (state) => {
  return state.user.roles
}

const getPromoUrl = (state) => {
  return state.promoUrl
}

const getMpcCode = (state) => {
  return state.mpcCode
}

const getPromoWidget = (state) => {
  return state.promoWidget
}

const getTranches = (state) => {
  return state.tranches
}

const getUserSettlementType = (state) => (type) => {
  return type ? state.user.settlement_type[type] : state.user.settlement_type
}

export default {
  getUser,
  getUserPending,
  getUserRoles,
  getPromoUrl,
  getMpcCode,
  getPromoWidget,
  getTranches,
  getUserSettlementType
}



// WEBPACK FOOTER //
// ./src/store/modules/account/getters.js